import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'mj-mojob-text-view',
  templateUrl: './mojobTextView.component.html',
  styleUrls: ['./mojobTextView.component.scss'],
})
export class MojobTextViewComponent {
  @Input() text: string = '';
  @Input() max_num_words: number = 500;
  @Input() max_num_words_breached_error: string = '';
  @Input() placeholder: string = '';
  @Output() textDidChange: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild('mojobTextViewContainer', { static: true })
  mojobTextViewContainer: ElementRef;

  public error: string = '';

  public state: string = 'INACTIVE';
  public word_count: number = 0;

  constructor() {
    this.word_count = this.countWords(this.text);
  }

  countWords(str) {
    if (str.length === 0) {
      return 0;
    }
    return str.trim().split(/\s+/).length;
  }

  shouldShowCorrect() {
    return (
      this.countWords(this.text) < this.max_num_words &&
      this.text.length > 0 &&
      this.state !== 'FOCUS'
    );
  }

  onTextChange() {
    this.word_count = this.countWords(this.text);

    if (this.word_count > this.max_num_words) {
      this.error = this.max_num_words_breached_error;
    } else {
      this.error = '';
    }

    this.textDidChange.emit(this.text);
  }

  inputOnFocus() {
    this.state = 'FOCUS';
  }

  inputOffFocus() {
    this.state = 'INACTIVE';
  }
}
